import { type Auth, api } from '@/lib/api'

// client: 'lab' on the code request too: the API sends a code to admin users
// only, and answers everyone else as an unknown number.
export const requestCode = (phone: string) =>
  api.post('/auth/otp', { phone, client: 'lab' }, false)

// client: 'lab' opens a lab session: one hour, renewed for a day, and the
// only kind of session the flag routes accept.
export const verifyCode = (phone: string, code: string) =>
  api.post<Auth>('/auth/verify', { phone, code, client: 'lab' }, false)
